import { BaseDto } from './base.dto';
import { EntityTypeDto } from './entityType.dto';
export enum EntityTypeFieldType{
    OTHER_BINARY_JSON = 0,
    TEXT,
    INTEGER,
    DOUBLE_CURRENCY_FLOAT,
    BOOLEAN,
    RELATIONSHIP,
    DATETIME
}
export class EntityTypeFieldDto extends BaseDto{

    entityTypeId?: number;
    entityType: EntityTypeDto;
    name: string;
    dbName: string;
    type: EntityTypeFieldType;
    typeMeta: string;
}